/* eslint-disable dot-notation */

// First of all setup logging and bugtracking to catch the most

import { setUuidDefaultEncoding } from '@zeed/zeed'
import { setupLogging } from '@/debug/logging'
import '@/lib/ocr'
import { removeSpinner } from '@/lib/spinner'

setUuidDefaultEncoding('base32')

// @ts-expect-error Dynamic MACOS for development, otherwise it will be set at compile time
globalThis['MACOS'] = navigator.userAgent.includes(' Doocs/')

setupLogging()

import('@/app/index')
  .then(async ({ setupApp }) => setupApp().then(removeSpinner).catch(() => { }))
  .catch(() => { })
